import { createRequest } from '@shared/services';

export async function getProductDescriptionTemplate() {
    const request = createRequest<DescriptionTemplateResponse>({
        url: '/product/description-template',
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function getProductDescriptionTemplateById(templateId: string) {
    const request = createRequest<DescriptionTemplateByIdResponse>({
        url: `/product/description-template/${templateId}`,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function postProductDescriptionTemplate(payload: DescriptionInfo) {
    const request = createRequest<DescriptionTemplateByIdResponse>({
        url: `/product/description-template`,
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putProductDescriptionTemplateById(
    templateId: string,
    payload: DescriptionInfo
) {
    const request = createRequest<DescriptionTemplateByIdResponse>({
        url: `/product/description-template/${templateId}`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function deleteDescriptionTemplateById(templateId: string) {
    const request = createRequest<DescriptionTemplateByIdResponse>({
        url: `/product/description-template/${templateId}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}

export async function deleteProductDescriptionTemplateById({
    templateId,
    productIds,
}: {
    templateId: string;
    productIds: string[];
}) {
    const searchParams = new URLSearchParams();

    productIds.forEach((id) => searchParams.append('product_id', id));

    const request = createRequest<DescriptionTemplateByIdResponse>({
        url: `/product/description-template/product/${templateId}?${searchParams.toString()}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}
